import * as breakpoint from './breakpoint.json';
/*
// sizeClass tokens will be imported from EGDS once they have been added to the breakpoint foundation token set
// the local breakpoint.json can then be deleted

import { EGDSTokens } from '@egds/tokens';
const tokens = new EGDSTokens({ brand: 'default' });
*/
export var SizeClassName;
(function (SizeClassName) {
    SizeClassName["EXTRA_SMALL"] = "EXTRA_SMALL";
    SizeClassName["SMALL"] = "SMALL";
    SizeClassName["MEDIUM"] = "MEDIUM";
    SizeClassName["LARGE"] = "LARGE";
    SizeClassName["EXTRA_LARGE"] = "EXTRA_LARGE";
    SizeClassName["EXTRA_EXTRA_LARGE"] = "EXTRA_EXTRA_LARGE";
})(SizeClassName || (SizeClassName = {}));
var getMinWidthOfSizeClass = function (sizeClassName) {
    var tokenName = "breakpoint__size_class__".concat(sizeClassName, "_min_width").toLowerCase();
    return breakpoint[tokenName].value;
    /*
    // replace return statement with this once sizeClass tokens are available from egds foundation
    return tokens.getToken(tokenName).value as number;
    */
};
var SizeClass = /** @class */ (function () {
    function SizeClass(sizeClass) {
        this.name = sizeClass;
        this.value = getMinWidthOfSizeClass(sizeClass);
    }
    SizeClass.prototype[Symbol.toPrimitive] = function (hint) {
        if (hint === 'number') {
            return this.value;
        }
        return this.name;
    };
    Object.defineProperty(SizeClass.prototype, Symbol.toStringTag, {
        get: function () {
            return 'SizeClass';
        },
        enumerable: false,
        configurable: true
    });
    return SizeClass;
}());
export { SizeClass };
export var SIZE_CLASSES = {
    EXTRA_EXTRA_LARGE: new SizeClass(SizeClassName.EXTRA_EXTRA_LARGE),
    EXTRA_LARGE: new SizeClass(SizeClassName.EXTRA_LARGE),
    LARGE: new SizeClass(SizeClassName.LARGE),
    MEDIUM: new SizeClass(SizeClassName.MEDIUM),
    SMALL: new SizeClass(SizeClassName.SMALL),
    EXTRA_SMALL: new SizeClass(SizeClassName.EXTRA_SMALL),
};
export var DEFAULT_SIZE_CLASS = SIZE_CLASSES.LARGE;
//# sourceMappingURL=size-class.js.map